module.exports = __webpack_public_path__ + "static/img/6197_phase_function_Paper_Points.4345872.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/6197_phase_function_Paper_Points.png
// module id = E0kT
// module chunks = 0